import { useState } from "react";
import { Link } from "react-router-dom";
import { Gift, ArrowRight, Check } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage, BACKEND_URL } from "@/lib/api";

export function DiscountForm({ pet, estimate }) {
  const [form, setForm] = useState({ name: "", phone: "", email: "", no_discount: false });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const barkibu = `${BACKEND_URL}/api/go/barkibu`;

  const submit = async (e) => {
    e.preventDefault();
    if (form.no_discount) { window.open(barkibu, "_blank", "noopener"); return; }
    setLoading(true);
    try {
      await api.post("/public/leads", { name: form.name, email: form.email, phone: form.phone || null, pet, estimate, consent_privacy: true, source: "calculator-discount" });
      localStorage.setItem("pp_exit_captured_v2", "1");
      setDone(true);
    } catch (err) { toast.error(errorMessage(err)); } finally { setLoading(false); }
  };

  if (done) return (
    <div id="attiva-sconto" className="rounded-2xl border-2 border-emerald-500 bg-emerald-500/10 p-6 text-center" data-testid="discount-success">
      <span className="mx-auto mb-3 grid h-12 w-12 place-items-center rounded-full bg-emerald-500 text-white"><Check /></span>
      <p className="font-display text-xl font-bold">Fatto, {form.name.split(" ")[0]}!</p>
      <p className="text-sm text-muted-foreground mt-1">Ti abbiamo appena inviato il codice sconto via email. Controlla anche la cartella Spam o Promozioni.</p>
      <a href={barkibu} target="_blank" rel="noopener noreferrer sponsored" className="btn-primary mt-5 inline-flex" data-testid="discount-success-go">Vai su Barkibu <ArrowRight size={16} /></a>
    </div>
  );

  return (
    <form id="attiva-sconto" onSubmit={submit} className="rounded-2xl border-2 border-amber-400 bg-amber-50 p-6 scroll-mt-20" data-testid="discount-form">
      <div className="flex items-start gap-3">
        <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-amber-500 text-white"><Gift size={22} /></span>
        <div>
          <h3 className="font-display text-xl font-bold leading-tight">Attiva il tuo sconto di 25€</h3>
          <p className="text-sm text-amber-900/80 mt-1">Ti mandiamo subito il codice privato via email, da usare su Barkibu.</p>
        </div>
      </div>
      <div className="grid gap-3 sm:grid-cols-3 mt-5">
        <input required className="input bg-white" placeholder="Nome" value={form.name} onChange={set("name")} data-testid="discount-name" />
        <input required type="tel" className="input bg-white" placeholder="Numero di telefono" value={form.phone} onChange={set("phone")} data-testid="discount-phone" />
        <input required={!form.no_discount} type="email" className="input bg-white" placeholder="Email" value={form.email} onChange={set("email")} data-testid="discount-email" />
      </div>
      <button className="btn-primary w-full mt-4 !py-3" disabled={loading} data-testid="discount-submit">
        {loading ? "Un attimo…" : form.no_discount ? <>Vai su Barkibu a prezzo pieno <ArrowRight size={16} /></> : <>Attiva il mio sconto di 25€ <ArrowRight size={16} /></>}
      </button>
      <label className="mt-4 flex items-start gap-2 text-xs text-muted-foreground cursor-pointer">
        <input type="checkbox" className="mt-0.5 accent-amber-500" checked={form.no_discount} onChange={set("no_discount")} data-testid="discount-refuse" />
        <span>Non voglio lo sconto di 25 euro</span>
      </label>
      <p className="mt-3 text-[10px] text-muted-foreground">Inviando accetti la <Link to="/privacy" className="underline">Privacy Policy</Link>. Usiamo i tuoi dati solo per inviarti il codice e, se vuoi, aiutarti a scegliere.</p>
    </form>
  );
}
